import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

export interface NewProjectDialogData {
  projectName: string;
}

@Component({
  selector: 'sw-new-project-dialog',
  templateUrl: 'new-project-dialog.html',
  styleUrls: ['../../../../scss/dialog-base.scss'],
})
export class NewProjectDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<NewProjectDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: NewProjectDialogData
  ) {}

  onNoClick(): void {
    this.dialogRef.close();
  }
}
